module.exports = __webpack_public_path__ + "img/mid_bathroom.da2a102c.jpg";